export const NOTIFICATION_TYPES = [
  { value: "announcement", label: "Announcement" },
  { value: "info", label: "Information" },
  { value: "success", label: "Success / good news" },
  { value: "warning", label: "Warning" },
  { value: "error", label: "Important alert" },
];

export const NOTIFICATION_PRIORITIES = [
  { value: "normal", label: "Normal" },
  { value: "high", label: "High — show prominently" },
  { value: "low", label: "Low" },
];

export function notificationTypeLabel(value) {
  return NOTIFICATION_TYPES.find((t) => t.value === value)?.label || value;
}

export function notificationPriorityLabel(value) {
  return NOTIFICATION_PRIORITIES.find((p) => p.value === value)?.label || value;
}
